import {useAccessLevel} from 'hooks/useAccessLevel';
import {useUserContext} from 'hooks/useUserContext';
import {PolicyType} from 'lib/policyUtils';

export const usePolicyToUpdate = () => {
  const user = useUserContext();
  const {isAdmin} = useAccessLevel();
  if (isAdmin) return;
  if (!user.termsOfServiceAcceptedAt || !user.termsOfServiceUrl) {
    return PolicyType.TERMS_OF_SERVICE;
  }
};
